import { createStaffAuthStore } from "@play/shared";

export type { AuthSession } from "@play/shared";

const store = createStaffAuthStore({
	storageKey: "play-card.session",
	persistence: "local",
});

export const {
	subscribeAuth,
	getSession,
	getAccessToken,
	getRefreshToken,
	isPortalAdmin,
	hasStaffTag,
	setSession,
	patchSession,
	clearSession,
	isAuthenticated,
	loginWithStaffSession,
	applyStaffAccess,
	applyStaffAccount,
} = store;
